import React from 'react';
import classes from './downloadApplication.module.css';
import Title from '../../containers/title/title';
import GooglePlayIcon from '../../../assets/images/google-store.png';
import Apple from '../../../assets/images/apple.png';
import { NavLink } from 'react-router-dom';


const DownloadApplication = (props) => {
    return (
        <div className={classes.DownloadApplication}>
            <Title title={props.appSection?.title} />
            <div className={classes.Container}>
                <p>{props.appSection?.content}</p>
                <span>
                    {parseInt(localStorage.getItem('language')) === 1 
                        ? "Download the app now" 
                        : "حمل التطبيق الآن"}
                </span>
                <div className={classes.DownloadButtons}>
                    <NavLink to={props.app?.android?.store_url} className={classes.ButtonContent} target='_blank'>
                        <img src={GooglePlayIcon} alt='google-store' />
                        <div>
                            <span>
                                {parseInt(localStorage.getItem('language')) === 1 
                                    ? "GET IT ON" 
                                    : "متوفر على"}
                            </span>
                            <span>Google Play</span>
                        </div>
                    </NavLink>
                    <NavLink to={props.app?.ios?.store_url} className={classes.ButtonContent} target='_blank'>
                        <img src={Apple} alt='app-store' />
                        <div>
                            <span>
                                {parseInt(localStorage.getItem('language')) === 1 
                                    ? "Download on the" 
                                    : "متوفر على"}
                            </span>
                            <span>App Store</span>
                        </div>
                    </NavLink>
                </div>
            </div>
        </div>
    )
}
export default DownloadApplication;